export default __webpack_public_path__ + "static/media/signupGoals.65ec4c20.jpg";